<template>
    <div id="oeeCasingGroupCount" :queryDate="queryDate"></div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import * as echarts from 'echarts';

export default {
    name: "oeeCasingGroupCount",
    mixins: [EmCommonApi],
    props: {
        queryDate: String,
    },
    data() {
        return {
            chart: {},
            deviceCodes: [],
            codeAndNameRelation: null,
            //dataValueX: ['S6-11 PAMA', 'S2-9 4.5米立车', 'S6-1 三菱镗床',
            //    'S6-3 昆明镗床', 'S2-8 CK5125B'],    //注意与系统参数定义的顺序保持一致，
            dataValueX: [],
            dataValueY_OEE: [],
            dataValueY_A: [],
            dataValueY_P: [],
            option: {},
            fresh: {},
            barMinWidth: 60,
            barMaxWidth: 60,
            receiveDate: '',
            queryType: 3        //Casing
        }
    },
    watch: {
        //监听queryDate的变化，这个queryDate是父组件传递的参数，利用watch监听再刷新当前子组件
        // queryDate(newValue, oldValue) {
        //     console.log("旧日期：" + oldValue + "父组件传递的新日期：" + newValue)
        //     this.getRemoteData();
        // }
    },
    created() {
        this.fetchData(3);
    },
    mounted() {
        //window.addEventListener('resize', this.chart.resize, false);

        //定时轮巡查询
        this.fresh = setInterval(() => {
            //子组件自己初始化查询日期
            if (this.queryDate === "") {
                this.receiveDate = this.formatDateTime(new Date());
            } else {
                this.receiveDate = this.queryDate;
            }
            console.log("【Oee】this paramDate=" + this.receiveDate)

            this.fetchData(3);
            window.addEventListener('resize', this.chart.resize, false)
        }, 30000);
    },
    beforeDestroy() {
        clearInterval(this.fresh);
        //window.removeEventListener('resize', this.chart.resize, false)
    },
    methods: {
        fetchData(type) {
            //1、取设备编码
            const _api = `${this.$_emApiMixin_moduleBaseApi("tpmOeeReportTor")}/tpmOeeReportTor/getDeviceCodesFromSysParam?type=`
                + type
            this.$_emApiMixin_get(_api, false).then(value => {
                let data = value;
                this.deviceCodes = data;
                //console.log('--------------- 调试：DeviceCodes from sysParam ----------------')
                //console.log(this.deviceCodes)
                //console.log(this.deviceCodes.length)

                //2、取设备编码和设备名称对应关系 getDeviceCodeAndNameRelationFromSysParam
                const _api = `${this.$_emApiMixin_moduleBaseApi("tpmOeeReportTor")}/tpmOeeReportTor/getDeviceCodeAndNameRelationFromSysParam`
                this.$_emApiMixin_get(_api, false).then(value => {
                    let data = value;
                    this.codeAndNameRelation = data;
                    //console.log('--------------- 调试：code and name relation ----------------')
                    //console.log(this.codeAndNameRelation)
                    //console.log(this.codeAndNameRelation["S1-19"])

                    //3、按系统参数取出的codes顺序拼code+name
                    this.spliceDeviceCodeAndName();
                    //4、取统计OEE
                    this.getRemoteData();
                })
            })
        },
        spliceDeviceCodeAndName() {
            //this.getDeviceCodesFromSysParam(3);
            //this.getDeviceCodeAndNameRelationFromSysParam();
            //每次需要重新清空
            this.dataValueX = [];
            this.deviceCodes.forEach((item, index) => {
                this.dataValueX.push(item + " " + this.codeAndNameRelation[item])
            });
        },
        getRemoteData() {
            let _this = this;

            const _api = `${this.$_emApiMixin_moduleBaseApi("tpmOeeReportTor")}/tpmOeeReportTor/getOeeRotorStatorStatistics?date=`
                + _this.receiveDate + "&type=" + this.queryType
            console.log(_api)

            //注意给后端传递年份查询参数 {s_year: this.year}
            this.$_emApiMixin_get(_api, false).then(value => {
                let data = value;
                //console.log('--------------- 调试：Casing 后端返回结果 ----------------')
                //console.log(data)

                //取对应属性的对象
                _this.dataValueY_OEE = data['OEE'];
                _this.dataValueY_A = data['A'];
                _this.dataValueY_P = data['P'];

                //渲染echart
                this.loadChart()
            })
        },
        formatDateTime(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
            const day = String(date.getDate()).padStart(2, '0');

            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        loadChart() {
            // 获取屏幕宽度
            const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            // 计算柱子宽度
            const autoBarWidth = Math.min(40, screenWidth / 20); // 40 是柱子的最大宽度，根据需要调整

            // 获取屏幕缩放比例动态计算
            let scale = window.devicePixelRatio || 1;
            // 设定原始字体大小（在100%缩放下的字体大小）
            let originalSize = 20; // 适合100%缩放的字体大小
            // 根据缩放比例调整字体大小
            let adjustedSize = originalSize * (1 / scale);

            this.option = {
                grid: {             //设置图标位置
                    left: '3%',     // 设置左边距为0%
                    right: '3%',    // 可选，设置右边距
                    bottom: '13%',  // 可选，设置底边距
                    top: '19%'      // 可选，设置顶边距
                },
                color: ['#9900CC', '#3399FF', '#33CC00'], // (全局)设置bar的颜色
                //backgroundColor: '#f4f4f4',     //背景色
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['OEE', 'A:时间利用率', 'P:性能利用率'],
                    top: 0,
                    textStyle: {
                        color: '#ffffff', // 设置图例文字颜色
                        fontSize: adjustedSize - 2,       // 设置 x 轴刻度标签的字体大小
                    },
                    itemWidth: adjustedSize + 3,   // 设置图例项的宽度
                    itemHeight: adjustedSize - 3,  // 设置图例项的高度
                },
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        mark: {show: true},
                        dataView: {show: true, readOnly: false},
                        magicType: {show: true, type: ['line', 'bar', 'stack']},
                        restore: {show: true},
                        saveAsImage: {show: true}
                    }
                },
                xAxis:
                    {
                        type: 'category',
                        axisTick: {show: false},
                        // data: ['Parts', 'Rotor & Stator', 'Casing'],
                        data: this.dataValueX,
                        axisLabel: {
                            textStyle: {
                                color: '#ffffff',   // 设置 x 轴刻度标签的字体颜色
                                fontSize: adjustedSize - 4,       // 设置 x 轴刻度标签的字体大小
                            }
                        }
                    },
                yAxis:
                    {
                        type: 'value',
                        axisLabel: {
                            textStyle: {
                                color: '#ffffff',   // 设置 x 轴刻度标签的字体颜色
                                fontSize: adjustedSize - 3,       // 设置 x 轴刻度标签的字体大小
                            },
                            formatter: '{value}%',    // 自定义标签格式
                        },
                        splitLine: {
                            show: true,             // 显示分隔线
                            lineStyle: {
                                color: 'rgba(255, 255, 255, 0.2)'  // 设置分隔线的颜色和透明度
                            }
                        },
                        //min: 0,   // 设置 Y 轴的最小值
                        //max: 100, // 设置 Y 轴的最大值
                    },
                series: [
                    {
                        name: 'OEE',
                        type: 'bar',
                        label: {
                            show: true, // 显示标签
                            position: 'top', // 标签位置，可以设置为 'top', 'insideTop' 等
                            color: '#ffffff', // 标签文字颜色
                            fontSize: adjustedSize - 2, // 标签文字大小
                            formatter: '{c}%' // 自定义标签格式
                        },
                        barGap: 0,
                        emphasis: {
                            focus: 'series'
                        },
                        //barMaxWidth: this.barMinWidth,    // 设置柱子的最大宽度
                        //barMinWidth: this.barMinWidth,    // 设置柱子的最小宽度
                        barWidth: autoBarWidth,         // 设置柱子的宽度
                        // data: [57, 81, 70]
                        data: this.dataValueY_OEE
                    },
                    {
                        name: 'A:时间利用率',
                        type: 'bar',
                        label: {
                            show: true, // 显示标签
                            position: 'top', // 标签位置，可以设置为 'top', 'insideTop' 等
                            color: '#ffffff', // 标签文字颜色
                            fontSize: adjustedSize - 2, // 标签文字大小
                            formatter: '{c}%' // 自定义标签格式
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        //barMaxWidth: this.barMinWidth,    // 设置柱子的最大宽度
                        //barMinWidth: this.barMinWidth,    // 设置柱子的最小宽度
                        barWidth: autoBarWidth,         // 设置柱子的宽度
                        // data: [62, 85, 73]
                        data: this.dataValueY_A
                    },
                    {
                        name: 'P:性能利用率',
                        type: 'bar',
                        label: {
                            show: true, // 显示标签
                            position: 'top', // 标签位置，可以设置为 'top', 'insideTop' 等
                            color: '#ffffff', // 标签文字颜色
                            fontSize: adjustedSize - 2, // 标签文字大小
                            formatter: '{c}%' // 自定义标签格式
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        //barMaxWidth: this.barMinWidth,    // 设置柱子的最大宽度
                        //barMinWidth: this.barMinWidth,    // 设置柱子的最小宽度
                        barWidth: autoBarWidth,         // 设置柱子的宽度
                        // data: [52, 77, 67]
                        data: this.dataValueY_P
                    },

                ]
            }
            this.chart = echarts.init(document.getElementById("oeeCasingGroupCount"));
            this.chart.setOption(this.option)

            //echart浏览器自动缩放
            let myChart = this.chart;
            window.addEventListener('resize', () => {
                myChart.resize();
            })
        }
    }
}
</script>

<style scoped>

</style>
